import { useMutation } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useRedemptionRequest = () => {
  return useMutation({
    mutationFn: async (redemptionData) => {
      const formData = new FormData();
      formData.append('national_id', redemptionData.nationalId);
      formData.append('redemption_type', redemptionData.redemptionType);
      formData.append('redemption_reason', redemptionData.redemptionReason);
      formData.append('bank_account', redemptionData.bankAccount);
      formData.append('bank_name', redemptionData.bankName);
      formData.append('account_holder_name', redemptionData.accountHolderName);
      formData.append('bank_branch', redemptionData.bankBranch);

      if (redemptionData.redemptionType === 'Partial') {
        if (redemptionData.amount) {
          formData.append('amount', redemptionData.amount);
        }
        if (redemptionData.percentage) {
          formData.append('percentage', redemptionData.percentage);
        }
      }

      if (redemptionData.idFront) {
        formData.append('id_front', redemptionData.idFront);
      }
      if (redemptionData.idBack) {
        formData.append('id_back', redemptionData.idBack);
      }

      const response = await apiClient.post('/redemption/request', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    },
  });
};

export { useRedemptionRequest };
